import React from 'react';
import { STATE_UI, statusIcons } from '../../utils/iconMap';

const LoaderIcon = statusIcons.loading;

/**
 * Boş / yükleme / hata / başarı — tekrarlayan blokları tek yapıda toplar.
 */
export default function StateSurface({
  variant = 'empty',
  title,
  description,
  icon: IconOverride,
  children,
  className = '',
  descriptionClassName = '',
  role: roleProp,
  ...rest
}) {
  const s = STATE_UI[variant] || STATE_UI.empty;
  const showLoader = variant === 'loading' && !IconOverride;
  const role = roleProp ?? (variant === 'error' ? 'alert' : undefined);

  return (
    <div className={`${s.container} ${className}`.trim()} role={role} {...rest}>
      {showLoader ? (
        <LoaderIcon className={`w-8 h-8 mx-auto mb-3 animate-spin ${s.icon}`} aria-hidden />
      ) : IconOverride ? (
        <IconOverride className={`w-10 h-10 mx-auto mb-3 ${s.icon}`} aria-hidden />
      ) : null}
      {title ? (
        <h2 className={s.title} style={variant === 'empty' ? { fontFamily: 'Cinzel, serif' } : undefined}>
          {title}
        </h2>
      ) : null}
      {description ? (
        <p className={`${s.body} ${descriptionClassName}`.trim()}>{description}</p>
      ) : null}
      {children}
    </div>
  );
}
